<template>
    <div class="pastMagazine-view">
        <div v-if="cateName !== 'cateName' && magazineName"
             class="pastMagazine-view-header">
            <div class="crumbs-nav-mask">
                <p :style="{color: themeColor}">{{ langTransfer('全部分类') }}</p>
                <i :style="{background: themeColor}"/>
                <p :style="{color: themeColor}">{{ cateName }}</p>
                <i :style="{background: themeColor}"/>
                <p :style="{color: themeColor}">{{ magazineName }}</p>
                <i :style="{background: themeColor}"/>
                <p :style="{color: themeColor}">{{ langTransfer('过往期刊') }}</p>
            </div>
        </div>
        <div class="pastMagazine-body-wrapper">
            <div class="years-mask">
                <h5>{{ langTransfer('全部过刊') }}</h5>
                <div ref="magazineYearsWrapper" class="magazine-years-wrapper">
                    <div class="years-list">
                        <div v-for="(item,index) in years"
                             :key="index"
                             class="year-item"
                             @click="changeYear(index)">
                            <p :style="{color: index === checkedYearIndex ? themeColor : ''}">
                                {{ `${item}年` }}
                            </p>
                            <span/>
                        </div>
                    </div>
                </div>
            </div>
            <div class="magazine-list-mask">
                <div class="magazine-list-header">
                    <h5 v-if="years.length > 0">
                        <i :style="{background: themeColor}" class="warning-icon"/>
                        {{ `${years[checkedYearIndex]}年` }}
                    </h5>
                </div>
                <div class="magazine-list-wrapper">
                    <div class="magazine-list-body">
                        <div class="list-body-mask">
                            <div v-for="(item,index) in magazines"
                                 :key="index"
                                 class="magazine-item"
                                 @click="goDetail(item)">
                                <img :src="item.__cover">
                                <h5>{{ item.Name }}</h5>
                                <span>{{ item.__midInfo }}</span>
                            </div>
                            <div class="magazine-item" style="height: 0;"/>
                            <div class="magazine-item" style="height: 0;"/>
                            <div class="magazine-item" style="height: 0;"/>
                        </div>
                        
                    </div>
                </div>
            </div>
           
        </div>
        <div class="site-footer">
            <Footer/>
        </div>
    </div>
</template>

<script>
    import BScroll from 'better-scroll'
    import Footer from '@/components/footer'
    export default {
        components: {
            Footer
        },
        data () {
            return {
                magazineListBScroll: null,
                magazineYearsBScroll: null,
                years: [],
                checkedYearIndex: 0,
                magazines: [],
                cateName: 'cateName',
                magazineName: '',
                lastParams: {}
            }
        },
        computed: {
            themeColor () {
                return this.$store.state.themeColor
            }
        },
        activated () {
        },
        mounted () {
            this.initBScroll()
        },
        methods: {
            initBScroll () {
                this.$nextTick(() => {
                    this.magazineListBScroll = new BScroll(this.$refs.magazineListWrapper, {
                        bounce: false,
                        click: true,
                        mouseWheel: {
                            speed: 20,
                            invert: false,
                            easeTime: 300
                        }
                    })
                    this.magazineYearsBScroll = new BScroll(this.$refs.magazineYearsWrapper, {
                        bounce: false,
                        click: true,
                        mouseWheel: {
                            speed: 20,
                            invert: false,
                            easeTime: 300
                        }
                    })
                })
            },
            changeYear (index) {
                if (this.checkedYearIndex === index) {
                    return
                }
                this.checkedYearIndex = index
                this.magazines = []
                this.getPastYearIssues()
            },
            goDetail (item) {
                this.$tools.goDetailRoute.call(this, 'magazine', item)
            },
            async getPastYears () {
                try {
                    const {
                        id
                    } = this.$route.params
                    const { Data } = await this.$apis('magazine').getPastYears(id)
                    this.years = Data
                    if (this.years.length > 0) {
                        this.getPastYearIssues()
                    }
                } catch (error) {
                    console.log(error)
                }
            },
            async getPastYearIssues () {
                try {
                    const {
                        id
                    } = this.$route.params
                    const {
                        years, checkedYearIndex
                    } = this
                    const year = years[checkedYearIndex]
                    const { Data } = await this.$apis('magazine').getPastYearIssues(id, year)
                    this.magazines = this.$tools.formatMagazineData(Data, '-l')
                    this.magazineName = this.magazines[0].Name
                } catch (error) {
                    console.log(error)
                }
            }
        },
        beforeRouteEnter (to, from, next) {
            next((vm) => {
                const { params } = vm.$route
                if (vm.$tools.isSameParams(params, vm.lastParams)) {
                    return
                }
                vm.lastParams = params
                const {
                    cateName
                } = params
                vm.cateName = cateName
                vm.years = []
                vm.magazines = []
                vm.magazineName = ''
                vm.getPastYears()
            })
        }
    }
</script>

<style lang="scss" scoped>
    .pastMagazine-view {
        width: 100%;
        margin: 0 auto;
        box-sizing: border-box;
        position: relative;
        margin-top: 30px;
    }

    .pastMagazine-view-header {
        width: 100%;
        height: 40px;
        box-sizing: border-box;
        background: #F6FAFF;
    }

    .crumbs-nav-mask {
        width: 1140px;
        height: 40px;
        margin: 0 auto;
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        align-items: center;

        p {
            
            font-size: 13px;
            color: #4BA8FF;
            letter-spacing: 0;
            cursor: pointer;
        }

        i {
            width: 1px;
            height: 12px;
            display: block;
            transform: rotate(20deg);
            background: #4BA8FF;
            border-radius: 100px;
            margin: 0 10px;
        }
    }

    .pastMagazine-body-wrapper {
        width: 1140px;
        // position: absolute;
        // top: 40px;
        // bottom: 20px;
        // left: 50%;
        // right: 0;
        // margin-left: -570px;
        // overflow: hidden;
        display: flex;
        flex-wrap: nowrap;
        justify-content: space-between;
        margin: auto;
        align-items: flex-start;
    }

    .pastMagazine-view-body {
        width: 1140px;
        height: 100%;
        margin: 0 auto;
        box-sizing: border-box;
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        align-items: flex-start;
        position: relative;
    }

    .years-mask {
        width: 270px;
        margin-right: 20px;
        background: #FFFFFF;
        box-shadow: 0 1px 3px 0 rgba(26,26,26,0.10);
        border-radius: 2px;

        h5 {
            width: 100%;
            height: 50px;
            box-sizing: border-box;
            padding: 0 16px;
            
            font-size: 16px;
            color: #1A1A1A;
            line-height: 50px;
            border-bottom: 1px solid #F0F2F7;
        }

        .magazine-years-wrapper {
            width: 100%;
            max-height: 336px;
            overflow: auto;
        }

        .years-list {
            padding: 8px 0;
        }

        .year-item {
            width: 100%;
            box-sizing: border-box;
            padding: 0 16px;
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            align-items: center;
            cursor: pointer;

            p {
                
                font-size: 14px;
                color: #1A1A1A;
                line-height: 40px;
                cursor: pointer;
            }

            span {
                
                font-size: 14px;
                color: #8590A6;
                text-align: right;
                line-height: 40px;
            }
        }

        .year-item:hover {
            background: #F6F6F6;
        }
    }

    .magazine-list-mask {
        //position: absolute;
        top: 0px;
        // bottom: 0;
        left: 290px;
        right: 0;
        background: #fff;
        box-shadow: 0 1px 3px 0 rgba(26,26,26,0.10);
        border-radius: 2px;
        width: 850px;
    }

    .magazine-list-header {
        width: 850px;
        height: 50px;
        box-sizing: border-box;
        padding: 0 34px 0 16px;
        background: #fff;
        border-bottom: 1px solid #F0F2F7;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;

        h5 {
            
            font-size: 16px;
            color: #1A1A1A;
            line-height: 50px;
            position: relative;
            padding-left: 12px;
        }

        .warning-icon {
            display: block;
            width: 4px;
            height: 16px;
            background: #0084FF;
            border-radius: 2px;
            position: absolute;
            left: 0;
            top: 17px;
        }
    }

    .magazine-list-wrapper {
        // overflow: hidden;
        // position: absolute;
        top: 50px;
        // bottom: 0;
        left: 0;
        right: 0;
    }

    .magazine-list-body {
        position: relative;
        min-height: 100%;
        box-sizing: border-box;
        padding: 16px 16px 16px;

        .list-body-mask {
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            align-items: flex-start;
            flex-wrap: wrap;
        }

        .magazine-item {
            width: 150px;
            height: 248px;
            margin-bottom: 16px;
            display: flex;
            flex-direction: column;
            justify-content: flex-start;
            align-items: flex-start;

            img {
                display: block;
                width: 150px;
                height: 190px;
                border-radius: 4px;
                cursor: pointer;
                background: #f6f6f6;
            }

            h5 {
                
                font-size: 16px;
                color: #1A1A1A;
                line-height: 22px;
                margin: 14px 0 8px;
                cursor: pointer;
            }

            span {
                display: block;
                
                font-size: 14px;
                color: #8590A6;
                line-height: 14px;
                cursor: pointer;
            }
        }
    }


    .site-footer {
        // position: absolute;
        bottom: 0;
        left: 0;
    }
</style>
